import create from '../utils/create';
export default create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      class: _vm.b()
    }, [_c('div', {
      class: _vm.b('wrap', {
        arc: _vm.arc
      }),
      style: _vm.imgWrapStyleCpd,
      on: {
        "click": _vm.photoClick
      }
    }, [_c('img', {
      style: _vm.imgStyleCpd,
      attrs: {
        "src": _vm.photoUrl
      }
    })]), _vm._t("default")], 2);
  },
  name: 'avatar',
  props: {
    photoUrl: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: 50
    },
    height: {
      type: Number,
      default: 50
    },
    borderWidth: {
      type: Number,
      default: 0
    },
    borderColor: {
      type: String,
      default: '#fff'
    },
    arc: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    /**
     * 根据props计算头像父元素的样式
     * @returns {Object} 计算后的样式
     */
    imgWrapStyleCpd: function imgWrapStyleCpd() {
      return {
        width: this.width + 2 * this.borderWidth + "px",
        height: this.height + 2 * this.borderWidth + "px",
        backgroundColor: this.borderColor
      };
    },

    /**
     * 根据props计算头像图片的样式
     * @returns {Object} 计算后的样式
     */
    imgStyleCpd: function imgStyleCpd() {
      return {
        width: this.width + "px",
        height: this.height + "px"
      };
    }
  },
  methods: {
    photoClick: function photoClick() {
      this.$emit('click');
    }
  }
});